import { render } from "./ActionsAttachmentTable.vue?vue&type=template&id=90fdd0a4&scoped=true"
import script from "./ActionsAttachmentTable.vue?vue&type=script&lang=js"
export * from "./ActionsAttachmentTable.vue?vue&type=script&lang=js"

import "./ActionsAttachmentTable.vue?vue&type=style&index=0&id=90fdd0a4&lang=scss&scoped=true"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-90fdd0a4"]])

export default __exports__